import { ref } from 'config/constants'
import { FETCH_CART } from './types';

const Carts = ref.child("carts");

/* Pampaign */
export function fetchCart(userid) {
  return dispatch => {
    Carts.child(userid).on('value', snapshot => {
      dispatch({
        type: FETCH_CART,
        payload: snapshot.val()
      });
    });
  };
}

export function createCart(userid, cart) {
  cart.userid = userid;
  return dispatch => Carts.child(userid).set(cart);
}

export function addToCart(userid, item) {
  item.userid = userid;
  return dispatch => Carts.child(userid).push(item);
}

export function removeFromCart(userid, key) {
  return dispatch => Carts.child(userid).child(key).remove();
}

export function updateCart(userid, key, item) {
  return dispatch => Carts.child(item.userid).child(key).set(item);
}



// WEBPACK FOOTER //
// ./src/data/carts/actions.js